import { useDashboardControls } from 'contexts/Dashboard/useDashboardControls';
import { maxManagementReportDateRangeMs } from 'constants/AppConstants';

/**
 * Delad plumbing för ledningsrapportens widgets.
 *
 * Alla sex läser samma filter och samma datumintervall, så filterobjektet byggs på ett ställe.
 * Utan det driver widgetarna isär och två paneler i samma rapport kan råka filtrera olika.
 */
const useManagementKpiFilter = () => {
  const {
    dashboardState: {
      daterange,
      selectedSupplierIDs,
      selectedCustomerNames,
      selectedFromCountyIDs,
      selectedToCountyIDs,
      groupingLevel,
      excludeCompanyNameContains,
    },
  } = useDashboardControls();

  const startDate = daterange[0];
  const endDate = daterange[1];

  const isDateRangeTooLong =
    !!startDate &&
    !!endDate &&
    endDate.getTime() - startDate.getTime() > maxManagementReportDateRangeMs;

  const isReady = !!startDate && !!endDate && !isDateRangeTooLong;

  return {
    startDate,
    endDate,
    isReady,
    isDateRangeTooLong,
    groupingLevel,
    /** Skickas som request-body till KPI-endpointen. */
    filter: {
      startDate: startDate as Date,
      endDate: endDate as Date,
      supplierIDs: selectedSupplierIDs,
      customerNames: selectedCustomerNames,
      fromCountyIDs: selectedFromCountyIDs,
      toCountyIDs: selectedToCountyIDs,
      groupBy: groupingLevel,
      excludeCompanyNameContains: excludeCompanyNameContains ?? undefined,
    },
    /** Beroendelista för useEffect — primitiva värden, så effekten inte loopar. */
    deps: [
      startDate ? startDate.getTime() : null,
      endDate ? endDate.getTime() : null,
      selectedSupplierIDs,
      selectedCustomerNames,
      selectedFromCountyIDs,
      selectedToCountyIDs,
      groupingLevel,
      excludeCompanyNameContains,
      isDateRangeTooLong,
    ] as const,
  };
};

export default useManagementKpiFilter;
